/* eslint-disable eqeqeq */
import { LuckyDrawRspDTO } from '__api/dsbc/safe/invDraw';
import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, ImageBackground } from 'react-native';

interface Props {
  onCancel?: Function;
}

interface State {
  isShow: boolean;
  data: LuckyDrawRspDTO[];
}

export class TenDrawCashPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
      data: [],
    };
  }

  show = (data: LuckyDrawRspDTO[]) => {
    this.setState({ isShow: true, data: data });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onCancel } = this.props;
    const { isShow, data } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <ImageBackground
                source={require('../../images/invite/awardDia.png')}
                resizeMode={'stretch'}
                style={styles.main}
              >
                <Spacer size={rpx(50)} />
                <View style={styles.main_c}>
                  {data.map((item, index) => {
                    if (item.rewardType == 1) {
                      return (
                        <View style={styles.item} key={index}>
                          <Image
                            style={styles.icon3Img}
                            source={require('../../images/invite/icon3.png')}
                            resizeMode={'stretch'}
                          />
                          <Text style={styles.text1}>{`${item.points}积分`}</Text>
                        </View>
                      );
                    } else if (item.rewardType == 2) {
                      return (
                        <View style={styles.item} key={index}>
                          <Image style={styles.icon3Img} source={{ uri: item.pic }} resizeMode={'stretch'} />
                          <Text style={styles.text1}>{item.title}</Text>
                        </View>
                      );
                    } else if (item.rewardType == 3) {
                      return (
                        <View style={styles.item} key={index}>
                          <ImageBackground
                            style={styles.icon3Img}
                            source={require('../../images/invite/smallRed.png')}
                            resizeMode={'stretch'}
                          >
                            <Text style={styles.textRed}>{`${item.giftValue}`}</Text>
                          </ImageBackground>
                          <Text style={styles.text1}>{`${item.giftValue}元`}</Text>
                        </View>
                      );
                    }
                  })}
                </View>
                <EmTouchableOpacity
                  activeOpacity={0.9}
                  style={styles.bottomBtn}
                  onPress={() => {
                    onCancel && onCancel();
                    this.hide();
                  }}
                >
                  <Image
                    style={styles.bottomImg}
                    source={require('../../images/invite/iKnow.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
                <Spacer size={rpx(20)} />
              </ImageBackground>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    height: rpx(394),
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  text: {
    fontSize: rpx(24),
    color: '#3A5DD7',
  },
  main_c: {
    width: rpx(300),
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  item: {
    width: rpx(56),
    height: rpx(79),
    alignItems: 'center',
    justifyContent: 'space-evenly',
    marginBottom: rpx(6),
    marginLeft: rpx(1.5),
    borderRadius: rpx(12),
    borderWidth: rpx(1),
    borderColor: '#FFE9C3',
  },
  icon3Img: {
    width: rpx(49),
    height: rpx(52),
    position: 'relative',
    alignItems: 'center',
  },
  textRed: {
    fontSize: rpx(12),
    color: '#FF222D',
    marginTop: rpx(10),
    fontWeight: 'bold',
  },
  text1: {
    fontSize: rpx(11),
    color: '#EA5504',
  },
  btnText: {
    fontSize: rpx(16),
    color: '#ffffff',
  },
  taskBtn: {
    width: rpx(250),
    height: rpx(40),
    borderRadius: rpx(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottomBtn: {
    position: 'absolute',
    bottom: rpx(30),
    width: rpx(210),
    height: rpx(51),
  },
  bottomImg: {
    width: rpx(210),
    height: rpx(51),
  },
});
